import { isFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import { isLocalDataBackedMailboxInfo } from 'owa-account-source-list/lib/utils/isLocalDataBackedAccount';

/**
 * PST Tasks are enabled if mon-pst-task feature flag is enabled and it's a PST account.
 */
export function arePstTasksEnabled(mailboxInfo?: MailboxInfo): boolean {
    return (
        !!mailboxInfo &&
        isLocalDataBackedMailboxInfo(mailboxInfo) &&
        isFeatureEnabled('mon-pst-task')
    );
}
